import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { List } from '../../models/list.model';
import { ApplicationHistoryDto } from '../../models/application-history.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class ApplicationHistoryService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  load(params: {
    appUuid: string;
    page: number;
    pageSize: number;
    sort: string;
    sortDirection: string;
    filters: string[];
  }): Observable<List<ApplicationHistoryDto>> {
    const url =
      `${
        this.configService.readConfig().baseUrlInfrastructure
      }/ApplicationHistory` +
      `?AppUuid=${params.appUuid}` +
      `&PageSize=${params.pageSize}` +
      `&PageNumber=${params.page}` +
      `&Sort=${params.sort}` +
      `&SortDirection=${params.sortDirection}` +
      `&Filter=${params.filters.join('&Filter=')}`;

    return this.http
      .get<List<ApplicationHistoryDto>>(url)
      .pipe(map((response) => response as List<ApplicationHistoryDto>));
  }
}
